import React from 'react';

const ModalToolbar: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div className="w-100 flex gap-4 rounded bg-blueGrayLightest p-4">
    {children}
  </div>
);

export default ModalToolbar;
